/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Validation_Invalid_EmailInputs */



/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Form_Validation_Invalid_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_invalid_email = /** @type {((inputs?: Form_Validation_Invalid_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Invalid_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte gib eine gültige E-Mail-Adresse ein")
	return /** @type {LocalizedString} */ ("Please enter a valid email address")
});